import React from 'react';
import * as apiActions from './actions/apiActions';


export const screenSizes = {
  xsMin: 0,
  xsMax: 575,
  smMin: 576,
  smMax: 767,
  mdMin: 768,
  mdMax: 991,
  lgMin: 992,
  lgMax: 1199,
  xlMin: 1200
};


export const camelize = (str) => {
  return str.replace(/\b\w/g, chr => chr.toUpperCase()).replace('-', ' ');
};
export const camelCaseToDashCase = string =>{
  return string.replace(/[\w]([A-Z])/g, function(m) {
    return m[0] + "-" + m[1];
  }).toLowerCase();
}
export const camelCaseToSnakeCase = string =>{
  return string.replace(/[\w]([A-Z])/g, function(m) {
    return m[0] + "_" + m[1];
  }).toLowerCase();
}
export const checkStatus = response => {
  if(response.ok) return response;
  else throw new Error(response.error);
};
export const cleanObj = myObj => {
  Object.keys(myObj).forEach(key => {
    !myObj[key] && delete myObj[key];
  });

  return myObj;
};
export const debounceEvent = (callback, time = 250) => {
  let interval;
  const debounced = (...args) => {
    clearTimeout(interval);
    interval = setTimeout(() => callback(...args), time);
  };
  debounced.cancel = () => {
    clearTimeout(interval);
  };
  return debounced;
};
export const deepClone = obj => {
  return JSON.parse(JSON.stringify(obj));
};
export const encodeData = data => {
  return Object.keys(data)
    .map(function(key){
      return [key, data[key]].map(encodeURIComponent).join('=');
    })
    .join('&');
};
export const getById = (state, id) => state.find(item => item.id === id || item.documentId === id);
export const getByCmsName = (state, cmsName) =>
  state.find(item => item.cmsName === cmsName || item.CMSName === cmsName);

/** First loaded singleton row in a module array (avoids empty LOAD_START placeholder at [0]). */
export const getLoadedModule = (state, predicate) => {
  if (!Array.isArray(state)) return state;
  if (typeof predicate === 'function') {
    return state.find(predicate);
  }
  return state.find(
    item =>
      item &&
      !item.isLoading &&
      !item.error &&
      (item.cmsName || item.title || item.botLeftText || item.legalText)
  );
};
export const getHighlightedText = (text, highlight) => {
  if(typeof highlight == 'undefined' || typeof text !== 'string') return text;

  // Split on highlight term and include term into parts, ignore case
  let parts = text.split(new RegExp(`(${highlight})`, 'gi'));
  return (
    <span>
      {' '}
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            part.toLowerCase() === highlight.toLowerCase()
            ? {fontWeight: 'bold'}
            : {}
          }
        >
          {part}
        </span>
      ))}{' '}
    </span>
  );
};
export const GetIEVersion = () => {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf('MSIE');

  // If IE, return version number.
  if(Idx > 0)
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));

  // If IE 11 then look for Updated user agent string.
  else if(navigator.userAgent.match(/Trident\/7\./))
    return 11;

  else
    return 0; //It is not IE
};
export const intersection = (array1, array2) => {
  return array1.filter(element => array2.includes(element));
};
export const isScreenLargerThan = (size) => {
  if(typeof size == 'string' && screenSizes[size]) return window.innerWidth > screenSizes[size];
  else if(!isNaN(size)) return window.innerWidth > size;
  else return null;
};
export const isScreenSmallerThan = (size) => {
  if(typeof size == 'string' && screenSizes[size]) return window.innerWidth < screenSizes[size];
  else if(!isNaN(size)) return window.innerWidth < size;
  else return null;
};
export const lowercaseFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};
export const mergeArraysWithoutDuplicatesBasedOnProperty = (a1, a2, propertyName) => {
  var ids = new Set(a1.map(d => d[propertyName]));
  return [...a1, ...a2.filter(d => !ids.has(d[propertyName]))];
};
export const mergeArrayofArraysWithoutDuplicatesBasedOnProperty = (arrays, propertyName) => {
  if(!arrays || !Array.isArray(arrays) || arrays.length < 1) return undefined;
  let newArray = [...arrays[0]];
  arrays.slice(1).forEach(otherArray => {
    mergeArraysWithoutDuplicatesBasedOnProperty(newArray, otherArray, propertyName);
  });

  return newArray;
};
export const multiFieldContainsQuery = (queryStr, endpoint, fieldNames, matchingField, generalFilters) => {
  //if querystring is empty or unset then we it's a call for the main list
  if(typeof queryStr == 'undefined' || queryStr.length < 1)
    return apiActions.loadEndpoint(endpoint, null, generalFilters);
  else
    return Promise.all(fieldNames.map(fieldName => {
      let filters = {...generalFilters};
      filters[`${fieldName}_contains`] = queryStr;

      return apiActions.loadEndpoint(endpoint, null, filters).catch(() => []);
    })).then(results => {
      return mergeArrayofArraysWithoutDuplicatesBasedOnProperty(results, matchingField).slice(0, generalFilters._limit);
    });
};
export const nLinks = text => {
  return text.split('\n').map(item => {
    return item;
  });
};
export const nToP = text => {
  return text.split('\n').map((item, i) => {
    return <p key={i}>{item}</p>;
  });
};
export const parseJSON = data => {
  return data.json();
};
export const toCamelCase = str => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) =>
      idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()
    )
    .replace(/\s+/g, '');
};
/***
 * replaceArrayItemsWithAnotherArrayBasedOnProperty
 * Pass in 2 arrays of objects and the name of a property to match
 *
 * @param a1 - primary array of objects
 * @param a2 - updating array of objects
 * @param propertyName - string name of property to match
 */
export const replaceArrayItemsWithAnotherArrayBasedOnProperty = (a1, a2, propertyName) => {
  return a1.map(
    (a) => {
      return this[a[propertyName]] || a;
    },
    a2.reduce((r, a) => {
      r[a[propertyName]] = a;
      return r;
    }, Object.create(null))
  );
};
export const trimToWord = (str, maxLength) => {
  if(!str) return str;
  var trimmedString = str.substr(0, maxLength);
  trimmedString = trimmedString.substr(
    0,
    Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
  );
  return trimmedString;
};

/** Split prose into sentences; ignores decimals like "3.5". */
export const splitSentences = (str) => {
  if (!str) return [];
  const sentences = [];
  let start = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str[i];
    if (c !== '.' && c !== '!' && c !== '?') continue;
    if (c === '.' && i > 0 && /\d/.test(str[i - 1])) continue;
    const next = str[i + 1];
    if (next != null && next !== ' ' && next !== '\n' && next !== '\r' && i + 1 !== str.length) {
      continue;
    }
    const chunk = str.slice(start, i + 1).trim();
    if (chunk) sentences.push(chunk);
    start = i + 1;
    while (start < str.length && /\s/.test(str[start])) start += 1;
    i = start - 1;
  }
  const tail = str.slice(start).trim();
  if (tail) sentences.push(tail);
  return sentences.length ? sentences : [str.trim()];
};

/**
 * Truncate at complete sentence(s), then comma clause, then word — never mid-sentence when avoidable.
 */
export const trimToCompleteThought = (str, maxLength) => {
  if (!str) return '';
  if (str.length <= maxLength) return str;

  const sentences = splitSentences(str);
  let result = '';
  for (const sentence of sentences) {
    const s = sentence.trim();
    if (!s) continue;
    const next = result ? `${result} ${s}` : s;
    if (next.length <= maxLength) {
      result = next;
    } else {
      break;
    }
  }
  if (result) return result;

  const first = sentences[0]?.trim() || str.trim();
  if (first.length <= maxLength) return first;

  const slice = first.slice(0, maxLength);
  const commaIdx = slice.lastIndexOf(', ');
  if (commaIdx > maxLength * 0.45) {
    return first.slice(0, commaIdx + 1).trim();
  }

  let sentEnd = -1;
  for (let i = slice.length - 1; i >= 0; i--) {
    const c = slice[i];
    if (c !== '.' && c !== '!' && c !== '?') continue;
    if (c === '.' && i > 0 && /\d/.test(slice[i - 1])) continue;
    sentEnd = i;
    break;
  }
  if (sentEnd >= 0) {
    return first.slice(0, sentEnd + 1).trim();
  }

  return trimToWord(first, maxLength);
};

/** Plain text for measuring markdown length (images stripped, link labels kept). */
export const plainTextFromMarkdown = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  let s = text;
  s = s.replace(/!\[([^\]]*)\]\([^)]*\)/g, (_, alt) => (alt && alt.trim()) || '');
  s = s.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/\*([^*]+)\*/g, '$1');
  s = s.replace(/__([^_]+)__/g, '$1');
  s = s.replace(/_([^_]+)_/g, '$1');
  s = s.replace(/^#{1,6}\s+/gm, '');
  s = s.replace(/^>\s?/gm, '');
  s = s.replace(/^[\s]*[-*+]\s+/gm, '');
  s = s.replace(/^\d+\.\s+/gm, '');
  return s.replace(/\s+/g, ' ').trim();
};

const isCtaOnlyParagraph = (paragraph) => {
  const plain = plainTextFromMarkdown(paragraph);
  return /^click here\b/i.test(plain) || /^https?:\/\//i.test(plain);
};

const isLinkOnlyParagraph = (paragraph) => {
  const trimmed = paragraph.trim();
  if (!trimmed) {
    return false;
  }
  return trimmed.split('\n').every((line) => /^\s*\[[^\]]+\]\([^)]+\)\s*$/.test(line));
};

/** Put markdown links back into a plain teaser when the label survived truncation. */
export const restoreMarkdownLinksInPlainTeaser = (originalMarkdown, plainTeaser) => {
  if (!plainTeaser) {
    return '';
  }

  let result = plainTeaser;
  const links = [];
  const linkRe = /\[([^\]]+)\]\(([^)]*)\)/g;
  let match;
  while ((match = linkRe.exec(originalMarkdown)) !== null) {
    links.push({label: match[1], full: match[0]});
  }
  links.sort((a, b) => b.label.length - a.label.length);

  for (const {label, full} of links) {
    if (result.includes(full) || !plainTeaser.includes(label)) {
      continue;
    }
    result = result.replace(label, full);
  }
  return result;
};

/**
 * Markdown teaser for project cards: first substantive paragraph plus following
 * link-only lines, preserving [label](url) syntax for MarkdownField rendering.
 */
export const extractMarkdownTeaser = (text, maxLength = 150) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  let s = text.replace(/\r\n/g, '\n');
  s = s.replace(/!\[([^\]]*)\]\([^)]*\)/g, (_, alt) => (alt && alt.trim()) || '');

  const paragraphs = s
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  const chunks = [];
  let usedPlain = 0;

  for (const paragraph of paragraphs) {
    if (isCtaOnlyParagraph(paragraph)) {
      continue;
    }

    const plain = plainTextFromMarkdown(paragraph);
    if (!plain) {
      continue;
    }

    if (chunks.length === 0) {
      if (plain.length > maxLength) {
        const truncatedPlain = trimToCompleteThought(plain, maxLength);
        chunks.push(restoreMarkdownLinksInPlainTeaser(paragraph, truncatedPlain));
        break;
      }
      chunks.push(paragraph);
      usedPlain = plain.length;
      continue;
    }

    if (!isLinkOnlyParagraph(paragraph)) {
      break;
    }

    if (usedPlain + 2 + plain.length > maxLength) {
      break;
    }

    chunks.push(paragraph);
    usedPlain += 2 + plain.length;
  }

  if (chunks.length > 0) {
    return chunks.join('\n\n');
  }

  const fallback = plainTextFromMarkdown(s.replace(/\n+/g, ' ').trim());
  if (!fallback || isCtaOnlyParagraph(fallback)) {
    return '';
  }
  return restoreMarkdownLinksInPlainTeaser(
    text,
    trimToCompleteThought(fallback, maxLength),
  );
};

/**
 * Plain-text teaser from markdown-rich CMS copy (e.g. project introDescription on cards).
 * Uses the first substantive paragraph; strips images, links, and common inline markers.
 */
export const stripMarkdownForTeaser = (text, maxLength = 150) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const teaser = extractMarkdownTeaser(text, maxLength);
  return plainTextFromMarkdown(teaser);
};
export const updateOrAddMany = (arr, items) => {
  items.forEach(item => arr = updateOrAdd(arr, item));
  return arr;
};
export const updateOrAdd = (arr, item) => {
  let replaced = false;
  let newArr = arr.map(arr_item => {
    let match = arr_item.id == item.id;
    replaced = match ? true : replaced;
    return match ? {...arr_item, ...item} : arr_item;
  });
  return replaced ? newArr : [...arr, item];
};
const toProjectFilterIdList = (filterProjectType) => {
  if (!filterProjectType) return [];
  if (Array.isArray(filterProjectType)) return filterProjectType.filter(Boolean);
  return String(filterProjectType).split(',').filter(Boolean);
};

const findById = (items, id) => {
  if (!items || id == null || id === '') return null;
  return items.find(item => String(item.id) === String(id)) || null;
};

/**
 * Build a descriptive document title for /projects based on active filters (WCAG 2.4.2).
 */
export const buildProjectsPageTitle = ({
  baseTitle = 'Our Projects',
  mProjectListMap,
  projectTypeList,
} = {}) => {
  if (!mProjectListMap) return baseTitle;

  const typeIds = toProjectFilterIdList(mProjectListMap.filter_projectType);
  const types = projectTypeList?.types || [];
  const typeTitles = typeIds
    .map(id => findById(types, id)?.title)
    .filter(Boolean);

  const descriptors = [];

  const program = findById(mProjectListMap.programs, mProjectListMap.filter_program);
  if (program?.title) descriptors.push(program.title);

  const status = findById(mProjectListMap.projectStatuses, mProjectListMap.filter_projectStatus);
  if (status?.title) descriptors.push(status.title);

  const search = (mProjectListMap.filter_title || '').trim();
  if (search) descriptors.push(`"${search}"`);

  const isMapView = mProjectListMap.viewMap === true || mProjectListMap.viewMap === 'true';

  if (typeTitles.length === 1 && descriptors.length === 0) {
    return isMapView ? `${typeTitles[0]} Projects Map View` : `${typeTitles[0]} Projects`;
  }

  const titleParts = [...typeTitles, ...descriptors];
  if (isMapView) titleParts.push('Map View');

  if (titleParts.length === 0) return baseTitle;

  if (titleParts.length === 1 && isMapView && typeTitles.length === 0) {
    return `${baseTitle} Map View`;
  }

  return `Projects: ${titleParts.join(', ')}`;
};

export const parseUrlSearch = (search = '') => {
  const query = search.startsWith('?') ? search.slice(1) : search;
  if (!query) {
    return {};
  }

  return query.split('&').reduce((obj, pair) => {
    const [rawKey, rawValue = ''] = pair.split('=');
    if (!rawKey) {
      return obj;
    }
    const key = decodeURIComponent(rawKey);
    const value = decodeURIComponent(rawValue);
    return {...obj, [key]: value};
  }, {});
};

export const buildProjectListFiltersFromUrlSearch = (search = '') => {
  const params = parseUrlSearch(search);

  return cleanObj({
    Program_in: params.Program_in,
    projectstatus_in: params.projectstatus_in,
    viewMap: params.viewMap === 'true',
    ProjectTypes_in: params.ProjectTypes_in ? params.ProjectTypes_in.split(',').filter(Boolean) : null,
    Title_contains: params.Title_contains,
  });
};

export const urlParams = () => {
  return parseUrlSearch(typeof location !== 'undefined' ? location.search : '');
};
export const handle404 = (history) => {
  history.replace('/404');
};

const normalizeProgramSlug = (program) =>
  (program?.slug || program?.Slug || '').toLowerCase();

const normalizeProgramTitle = (program) =>
  (program?.title || program?.Title || '').trim().toLowerCase();

export const isVisionZeroProgram = (program) => {
  if (!program) return false;

  return normalizeProgramSlug(program) === 'vision-zero'
    || normalizeProgramTitle(program) === 'vision zero';
};

/** Vision Zero badges use black label text; all other programs stay white (prod + LLSU2-114). */
export const programBannerTextColor = (program) =>
  isVisionZeroProgram(program) ? 'black' : 'white';

/** Event cards: related program color, grey only when no program color is set (LLSU2-245). */
export const programColor = (program, fallback = '#cccccc') =>
  (program && (program.color || program.Color)) || fallback;
